import React from 'react';
import { Link } from 'react-router-dom';

const TosSections = () => (
  <>
    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">8. Disclaimer of Warranties</h2>
    <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-4">
      <p className="text-slate-700 font-semibold mb-2">IMPORTANT: INVESTMENT DISCLAIMER</p>
      <p className="text-slate-700 text-sm">MyInvestFolio is a private investment infrastructure that helps you record, organise and safeguard information about assets you already own &mdash; including the Continuity System for controlled information transfer, and, for Portfolio Clarity subscribers, analytics and reporting on the assets you have recorded. We are <strong>not</strong> a broker, custodian, investment adviser, or financial planner. We do not provide investment advice, buy or sell recommendations, tax advice, or financial planning services, and nothing shown in the Service constitutes an offer or recommendation to buy, sell, or hold any investment. The Service is provided &ldquo;AS IS&rdquo; without warranties of any kind. All investment decisions remain solely yours &mdash; please consult a qualified financial adviser, tax adviser, or solicitor licensed in your jurisdiction before acting on anything you see here.</p>
    </div>
    <p className="text-slate-700 mb-4">We make no warranties that:</p>
    <ul className="list-disc pl-6 text-slate-700 mb-4 space-y-2">
      <li>The Service will be uninterrupted or error-free</li>
      <li>Data will be accurate, complete, or reliable</li>
      <li>Results obtained from the Service will meet your expectations</li>
    </ul>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">9. Limitation of Liability</h2>
    <p className="text-slate-700 mb-4">TO THE MAXIMUM EXTENT PERMITTED BY LAW, MyInvestFolio SHALL NOT BE LIABLE FOR:</p>
    <ul className="list-disc pl-6 text-slate-700 mb-4 space-y-2">
      <li>Any investment losses or financial damages</li>
      <li>Indirect, incidental, special, or consequential damages</li>
      <li>Loss of profits, revenue, data, or business opportunities</li>
      <li>Errors or inaccuracies in portfolio data or calculations</li>
    </ul>
    <p className="text-slate-700 mb-4">Our total liability shall not exceed the amount you paid for the Service in the 12 months prior to the claim.</p>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">10. Indemnification</h2>
    <p className="text-slate-700 mb-4">You agree to indemnify and hold harmless MyInvestFolio from any claims, damages, or expenses arising from your use of the Service or violation of these Terms.</p>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">11. Data and Privacy</h2>
    <p className="text-slate-700 mb-4">Your use of the Service is subject to our <Link to="/privacy-policy" className="text-emerald-600 hover:underline">Privacy Policy</Link>. We recommend reviewing it carefully.</p>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">12. Termination</h2>
    <p className="text-slate-700 mb-4">We may suspend or terminate your account at any time for:</p>
    <ul className="list-disc pl-6 text-slate-700 mb-4 space-y-2">
      <li>Violation of these Terms</li>
      <li>Fraudulent or illegal activity</li>
      <li>Non-payment of subscription fees</li>
      <li>Extended inactivity</li>
    </ul>
    <p className="text-slate-700 mb-4">You may cancel your subscription at any time through your account settings.</p>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">13. Changes to Terms</h2>
    <p className="text-slate-700 mb-4">We reserve the right to modify these Terms at any time. Significant changes will be communicated via email. Continued use of the Service after changes constitutes acceptance.</p>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">14. Governing Law &amp; Jurisdiction</h2>
    <p className="text-slate-700 mb-4"><strong>Primary Jurisdiction:</strong> These Terms are governed by the laws of the State of Wyoming and the United States of America.</p>
    <p className="text-slate-700 mb-4"><strong>International Users:</strong> While our primary jurisdiction is the United States, MyInvestFolio serves users globally across multiple countries and currencies. By using the Service:</p>
    <ul className="list-disc pl-6 text-slate-700 mb-4 space-y-2">
      <li>You agree that United States law governs the interpretation of these Terms</li>
      <li>You acknowledge that your use of the Service must also comply with the laws of your country of residence</li>
      <li>For users outside the United States, disputes may be resolved in the courts of your local jurisdiction where permitted by law</li>
      <li>We make reasonable efforts to comply with applicable international data protection laws (such as GDPR)</li>
    </ul>
    <p className="text-slate-700 mb-4"><strong>Dispute Resolution:</strong> Any disputes shall be resolved through:</p>
    <ol className="list-decimal pl-6 text-slate-700 mb-4 space-y-2">
      <li>Good faith negotiation between parties</li>
      <li>Mediation (if negotiation fails)</li>
      <li>Arbitration or court proceedings in the State of Wyoming, United States (or your local jurisdiction if outside the United States)</li>
    </ol>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">15. Multi-Country Operations</h2>
    <p className="text-slate-700 mb-4">MyInvestFolio is designed to serve investors globally. We support multiple currencies and recognise investments from various countries. Each user&rsquo;s data is protected according to:</p>
    <ul className="list-disc pl-6 text-slate-700 mb-4 space-y-2">
      <li>US federal and state privacy laws (primary)</li>
      <li>GDPR (for EU and UK users)</li>
      <li>Applicable local data protection regulations in your jurisdiction</li>
    </ul>

    <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">16. Contact Information</h2>
    <p className="text-slate-700 mb-4">For questions about these Terms, contact us at:</p>
    <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
      <p className="text-slate-700"><strong>Email:</strong> legal@myinvestfolio.io</p>
      <p className="text-slate-700"><strong>Support:</strong> support@myinvestfolio.io</p>
      <p className="text-slate-700"><strong>Primary Office:</strong> United States of America</p>
    </div>
  </>
);

export default TosSections;
